import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import Slider from "react-slick";
import { AppContext } from '../../../AppContext';

const Banner = () => {
    const { appState } = useContext(AppContext);
    const { banner, title, video = "https://varefiles.s3.us-east-2.amazonaws.com/hh-banking-video-compress.mp4" } = appState.banner || {};

    const settings = {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        arrows: false,
        infinite: true,
        autoplay: true,
        speed: 400,
        focusOnSelect: true,
        cssEase: 'linear'
    };

    if (!banner?.[0]) {
        return
    }

    return (
        <div className="slider video-banner">
            {/* <div className="side-lines">
                <span className="box" />
                <span className="text">{title}</span>
                <span className="line" />
            </div> */}
            <video playsInline className="jarallax" autoPlay muted loop>
                <source src={video} type="video/mp4" />
            </video>
            <div className="transform-center">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <Slider className="banner-slider" {...settings}>
                                {banner?.map((item, i) => (
                                    <div key={i} className="slide-item" >
                                        <div className="banner-text" style={{
                                            marginLeft: 50
                                        }}>
                                            <h1 className="text-custom-white fw-700">{item.title}</h1>
                                            <p className="text-custom-white">{item.text}</p>
                                            <Link
                                                onClick={() => {
                                                    window.open(item?.link, '_self')
                                                }}
                                                className="btn-first btn-submit-fill">{item?.buttonText}</Link>
                                        </div>
                                    </div>
                                ))}
                            </Slider>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Banner;
